<template>
  <v-card class="card">
    <div class="cabecera">
      <div class="seccion-label mb-0">
        Productos
      </div>
      <div class="acciones">
        <v-btn
          variant="outlined"
          color="primary"
          size="small"
          @click="dialogCartaOpen = true"
        >
          <v-icon start>
            mdi-file-document-outline
          </v-icon>
          Cargar carta
        </v-btn>
        <v-btn
          class="bg-blue"
          size="small"
          @click="dialogOpen = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>

    <div
      v-if="cargandoLista"
      class="estado"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="30"
        width="3"
      />
      <span>Cargando productos...</span>
    </div>

    <div
      v-else-if="errorLista"
      class="estado"
    >
      <v-icon
        size="30"
        color="error"
      >
        mdi-alert-circle-outline
      </v-icon>
      <span>No se pudieron cargar los productos</span>
      <v-btn
        class="bg-blue"
        size="small"
        @click="cargarProductos"
      >
        Reintentar
      </v-btn>
    </div>

    <div
      v-else-if="ids.length === 0"
      class="estado"
    >
      <v-icon
        size="38"
        color="grey"
      >
        mdi-package-variant
      </v-icon>
      <span>Esta empresa todavia no tiene productos</span>
      <v-btn
        class="bg-blue"
        size="small"
        @click="dialogOpen = true"
      >
        Agregar el primero
      </v-btn>
    </div>

    <div
      v-else
      class="grilla"
    >
      <TarjetaEdicionProducto
        v-for="id in ids"
        :key="id"
        :id-producto="id"
        @editar="abrirEdicion"
        @eliminar="pedirConfirmacion"
      />
    </div>

    <v-dialog
      v-model="dialogOpen"
      max-width="600"
    >
      <NewPorduct
        :id-company="idCompany"
        @alRegistrarCorrectamente="cargarProductos()"
        @onClose="dialogOpen = false"
      />
    </v-dialog>

    <!-- persistent: mientras Claude lee la carta, un clic afuera no debe
         cerrar el modal y dejar al usuario sin ver el resultado -->
    <v-dialog
      v-model="dialogCartaOpen"
      max-width="560"
      persistent
    >
      <CargarCartaModal
        :id-company="idCompany"
        :con-hospedaje="conHospedaje"
        @alTerminar="cargarProductos()"
        @onClose="dialogCartaOpen = false"
      />
    </v-dialog>

    <v-dialog
      v-model="dialogEditOpen"
      max-width="600"
    >
      <EditProduct
        v-if="idEnEdicion"
        :product-id="idEnEdicion"
        @alEditarCorrectamente="cargarProductos()"
        @onClose="dialogEditOpen = false"
      />
    </v-dialog>

    <!-- UN SOLO dialogo de borrado para toda la lista. Antes habia uno DENTRO
         del v-for, los N atados al mismo booleano: al pulsar eliminar se
         abrian todos a la vez y el boton Delete que quedaba encima podia
         borrar un producto distinto al que se pulso. -->
    <v-dialog
      v-model="dialogDeleteOpen"
      max-width="420"
      :persistent="eliminando"
    >
      <v-card class="modal modal-confirmar">
        <div class="modal-confirmar-cabecera">
          <div class="modal-confirmar-icono">
            <v-icon size="20">
              mdi-alert-outline
            </v-icon>
          </div>
          <h2 class="modal-confirmar-titulo">
          Eliminar producto
          </h2>
        </div>

        <v-card-text class="modal-confirmar-cuerpo">
          <p v-if="porEliminar && porEliminar.nombre">
            Se va a eliminar <strong>{{ porEliminar.nombre }}</strong>.
          </p>
          <p v-else>
            Se va a eliminar este producto.
          </p>
          <p class="modal-irreversible">
            Esta acción no se puede deshacer.
          </p>
        </v-card-text>
        <v-card-actions class="modal-confirmar-pie">
          <v-spacer />
          <v-btn
            variant="text"
            :disabled="eliminando"
            @click="dialogDeleteOpen = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="red"
            variant="flat"
            :loading="eliminando"
            @click="eliminarProducto"
          >
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="aviso"
      :timeout="colorAviso === 'error' ? -1 : 4000"
      :color="colorAviso"
      location="top"
    >
      {{ mensajeAviso }}
      <template #actions>
        <v-btn
          variant="text"
          size="small"
          @click="aviso = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import apisProducts from '@/apis/apisProducts'
import EditProduct from './EditProduct.vue'
import NewPorduct from './NewProduct.vue'
import TarjetaEdicionProducto from './TarjetaEdicionProducto.vue'
import CargarCartaModal from './CargarCartaModal.vue'

/**
 * Productos de la empresa en modo tarjetas.
 *
 * Antes era una tabla de seis columnas con min-width 600px: en celular
 * obligaba a desplazar de lado dentro de la pestana.
 *
 * Este panel solo pide la LISTA y se queda con los ids; cada tarjeta carga
 * sus propios datos y su propia imagen.
 */
export default {
  name: 'PanelEdicionProductos',
  components: { NewPorduct, EditProduct, TarjetaEdicionProducto, CargarCartaModal },
  props: {
    idCompany: {
      type: Number,
      required: true
    },
    // null mientras no se sabe; la carga de carta solo va con hospedaje vigente
    conHospedaje: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      ids: [],
      cargandoLista: true,
      errorLista: false,
      dialogOpen: false,
      dialogCartaOpen: false,
      dialogEditOpen: false,
      idEnEdicion: null,
      dialogDeleteOpen: false,
      porEliminar: null,
      eliminando: false,
      aviso: false,
      mensajeAviso: '',
      colorAviso: 'success'
    }
  },
  created() {
    this.cargarProductos()
  },
  methods: {
    cargarProductos() {
      this.cargandoLista = true
      this.errorLista = false

      apisProducts.getProductsCompany(this.idCompany)
        .then(productos => {
          this.ids = (productos || []).map(p => p.idProduct)
        })
        .catch(() => {
          this.errorLista = true
        })
        .finally(() => {
          this.cargandoLista = false
          this.dialogOpen = false
          this.dialogEditOpen = false
        })
    },
    abrirEdicion(idProducto) {
      this.idEnEdicion = idProducto
      this.dialogEditOpen = true
    },
    pedirConfirmacion(producto) {
      this.porEliminar = producto
      this.dialogDeleteOpen = true
    },
    eliminarProducto() {
      if (!this.porEliminar) {
        return
      }

      this.eliminando = true

      apisProducts.deleteProduct(this.porEliminar.id)
        .then(() => {
          this.dialogDeleteOpen = false
          this.avisar('Producto eliminado', 'success')
          this.cargarProductos()
        })
        .catch(error => {
          // Antes esto solo hacia console.error: el dialogo se quedaba
          // abierto y el usuario no se enteraba de que habia fallado.
          this.avisar(
            error?.response?.data?.message
              || error?.message
              || 'No se pudo eliminar el producto',
            'error'
          )
        })
        .finally(() => {
          this.eliminando = false
          this.porEliminar = null
        })
    },
    avisar(mensaje, color) {
      this.mensajeAviso = mensaje
      this.colorAviso = color
      this.aviso = true
    }
  }
}
</script>

<style scoped>
.card {
  padding: 14px 16px;
}
.cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}
.acciones {
  display: flex;
  align-items: center;
  gap: 8px;
}
.seccion-label {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #1976d2;
}

/* Mobile first: dos por fila desde el arranque, que las tarjetas son
   angostas, y mas columnas segun crece el panel */
.grilla {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
@media (min-width: 700px) {
  .grilla {
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
  }
}
@media (min-width: 1000px) {
  .grilla {
    grid-template-columns: repeat(4, 1fr);
  }
}

.estado {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 12px;
  color: #667085;
  font-size: 0.88rem;
  text-align: center;
}
</style>
